import TechnicianUnavailabilitiesDownloader from "../data/technician/TechnicianUnavailabilitiesDownloader";

export function UnavailabilitiesDrawer() {
  return (
    <div className="p-4 h-[90%]">
      <TechnicianUnavailabilitiesDownloader />
    </div>
  );
} 